import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { getAdminCheckins } from "../api/adminCheckins";

const formatDate = (value) => value ? new Date(value).toLocaleDateString("nl-BE") : "-";
const formatDateTime = (value) => value ? new Date(value).toLocaleString("nl-BE") : "-";

export default function AdminCheckins() {
  const { data = [], isLoading, isError, error } = useQuery({
    queryKey: ["admin", "checkins"],
    queryFn: getAdminCheckins
  });

  if (isLoading) return <div className="loading-state">Check-ins laden...</div>;

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Check-ins</h1>
          <p className="page-subtitle">Ontvang verhuurde trailers terug en controleer schade, foto's en opties.</p>
        </div>
      </header>

      {isError ? (
        <div className="panel panel-pad error-text">{error?.response?.data?.error || "Check-ins ophalen mislukt."}</div>
      ) : data.length === 0 ? (
        <div className="panel empty-state">Geen openstaande of bevestigde check-ins gevonden.</div>
      ) : (
        <div className="panel table-panel">
          <table className="data-table">
            <thead>
              <tr>
                <th>Reservatie</th>
                <th>Klant</th>
                <th>Trailer</th>
                <th>Terugdatum</th>
                <th>Status</th>
                <th>Issues</th>
                <th>Foto's</th>
                <th>Bevestigd</th>
                <th>Actie</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={`${item.type}-${item.checkInInspectionId || item.reservationId}`}>
                  <td>#{item.reservationId}</td>
                  <td>{item.reservation?.firstName || item.customer?.firstName || ""} {item.reservation?.name || item.customer?.lastName || "-"}</td>
                  <td>{item.trailer?.name || `#${item.reservation?.trailerId || "-"}`}</td>
                  <td>{formatDate(item.returnDate || item.reservation?.endDate)}</td>
                  <td>
                    {item.checkInStatus === "PENDING" ? (
                      <span className="badge warning">Nog in te checken</span>
                    ) : (
                      <span className="badge success">Ingecheckt</span>
                    )}
                    <span className="badge info" style={{ marginLeft: 6 }}>{item.reservation?.status || item.status}</span>
                  </td>
                  <td>{item.hasIssues ? <span className="badge danger">Ja</span> : <span className="badge success">Nee</span>}</td>
                  <td>{item.photos?.length || 0}</td>
                  <td>{formatDateTime(item.confirmedAt)}</td>
                  <td>
                    {item.checkInStatus === "PENDING" ? (
                      <Link className="button" to={`/admin/checkins/reservation/${item.reservationId}/start`}>
                        Check-in uitvoeren
                      </Link>
                    ) : (
                      <Link className="button secondary" to={`/admin/checkins/${item.checkInInspectionId}`}>
                        Bekijk check-in
                      </Link>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
